import "react-app-polyfill/stable"
import "core-js"
import React from "react"
import App from "./App"
import store from "./store"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import { createRoot } from "react-dom/client"

createRoot(document.getElementById("root")).render(
  <Provider store={store}><App /></Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()